import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdAddBox } from "react-icons/md";
import colors from "../../config/colors";
import apiClient from "../../api/apiClient";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";

export default () => {
  const [vehicles, setVehicles] = useState([]);
  const[ Loading, setLoading]=useState(false)
  const fetch = async () => {
    setLoading(true);
    // try {
      const response = await apiClient.get("/vehicles/vehicles/");
      setLoading(false)
      if(!response.ok) return console.log("error")

        setVehicles(response?.data);
 
  };
  
  useEffect(() => {
    fetch();
  }, []);
  const vehicletype = (item) => {
    if (item === 1) {
      return "Truck";
    } else if (item === 2) {
      return "Car";
    } else if (item === 3) {
      return "Semi Truck";
    } else if (item === 4) {
      return "Box Truck";
    } else if (item === 5) {
      return "Bus";
    } else if (item === 6) {
      return "Van";
    }
  };

  const handleDelete = async (id) => {
    setLoading(true)
    try {
      const result = await apiClient.delete(`/vehicles/vehicles/${id}/`);
      if (result.ok) {
        toast.success('Vehicle Deleted');
        // If deletion is successful, refetch the updated data
        fetch();
      } else {
        toast.error('Error deleting vehicle');
      }
    } catch (error) {
      console.error('Error deleting vehicle:', error);
      toast.error('Error deleting vehicle');
    }finally {
      setLoading(false); // Set loading to false after API request is complete
    }
  };


  return (
    <div className="site-content h-100">
      <div className="">
        <div className="site-content-body">
          <div className="main_bg_color h-100">
            <div className="container-fluid">
              <div className="row py-3">

            { !Loading   ?   
                vehicles.map((vehicle) => (
                  <div className="col-lg-4 col-md-6 sm-col-12 px-4 mb-5">
                    <div>
                      <div className="card card_border div_posetion">
                        <img
                          className=""
                          src={vehicle.frontside_image}
                          alt="Card image"
                          style={{ width: "100%", height: "200px" }}
                        />
                        <div className="photo_button d-flex justify-content-between">
                          <button className="px-3 py-2 rounded-pill bg-dark">
                            {/* <b>{vehicletype(vehicle.vehicle_type)}</b> */}

                            <b>{vehicle.vehicle_type}</b>
                          
                          </button>
                        </div>
                        <div className="d-flex flex-column edit_del_button">
                          <i className=" bi bi-trash fs-3 text-danger pb-2" style={{cursor:"pointer"}} onClick={()=>handleDelete(vehicle.id)} />
                          <Link
                            to="/vehicleowneraddvehicle"
                            state={{ item: vehicle }}
                          >
                            <i className="bi bi-pencil text-primary fs-3" />
                          </Link>
                        </div>
                        {/* <div className="nike_chat_icon"><i className="bi bi-chat-left-fill fa-2x" />
                                </div> */}
                        <div className=" job_bg py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                          <p className="mb-1">
                            Vehicle:
                            <span>{`${vehicle.vehicle_year},${vehicle.vehicle_model}`}</span>
                          </p>
                          <p className="mb-1">
                            License Plate: <span>{vehicle.license_plate}</span>
                          </p>


                          {vehicle.vehicle_length==0?"":  <p className="">
                            Vehicle Length:
                            <span>{vehicle.vehicle_length}ft</span>
                          </p>}
                        </div>
                      </div>
                    </div>
                  </div>
                )):<div className="text-center mt-3">
                <h1>       <CircularProgress /></h1>
              </div>}

              </div>
                <div className=" px-4 mb-5 d-flex justify-content-center align-items-center">
                  <div className="">
                    <Link
                      to={"/vehicleowneraddvehicle"}
                      style={{ textDecoration: "none" }}
                    >
                      <MdAddBox color={colors.primary} size={200} />
                      <h5
                        className="d-flex justify-content-center"
                        style={{ color: "#005E9D" }}
                      >
                        Add Vehicle
                      </h5>
                    </Link>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
